import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, Icon, Input, Badge, Button, DatePicker, Table } from "antd";
import { OrderedMap } from "immutable";
import moment from "moment";
import _debounce from "lodash/debounce";
import keyMirror from "key-mirror";
import { STATE_STATUS } from "../constants";
import "styles/review-invoices.css";
const { RangePicker } = DatePicker;

const CARD_LABELS = {
    total_request_invoices: "Total requests",
    total_request_pending_invoices: "Pending requests",
    total_request_verified_invoices: "Approved requests",
    total_request_rejected_invoices: "Rejected requests",

};

const CARD_STATUS = {
    total_request_invoices: "total",
    total_request_pending_invoices: "PENDING",
    total_request_verified_invoices: "approved",
    total_request_rejected_invoices: "rejected",
};

const JOB_STAGES_FOR_REVIEWER = [
    "Review Pending",
    "Review Closed",
    "Initialized",
    "Processing",
    "Review Initialized",
    "Processed",
    "Pending Admin Approval",
    "Pending For Rate Per Unit",
    "Pending For WCTL",
    "Pending For Flexible Tenor And Roi"
];

const JOB_STAGES = new keyMirror({
    "Initialized": null,
    "Pending": null,
    "Processed": null,
    "Review Initialized": null,
    "Review Pending": null,
    "Review Closed": null
});

const DEFAULT_PAGE_SIZE = 20;

class ReviewInvoices extends Component {

    state = {
        searchValue: this.props.filter.search || "",
        start_date: "",
        end_date: ""
    };


    componentDidUpdate(prevProps) {
        // this.updateFilters();
        // if (prevProps.filter.search !== this.props.filter.search) {
        //     this.updateFilters();
        // }
    }


    componentDidMount() {
        this.fetchData();
        // this.updateFilters();
    }

    // updateFilters() {
    //     if(this.props.filter.search && this.props.filter.search.length > 0 && (!this.state.searchValue || this.state.searchValue.length == 0)) {
    //         this.setState({
    //             searchValue: this.props.filter.search
    //         });
    //     }
    // }

    updateFilters() {
        if (
            this.state.searchValue === null &&
            typeof this.props.filter.search === "string"
        ) {
            this.setState({
                searchValue: this.props.filter.search
            });
        }
    }
    

    fetchData() {
        if (this.props.jobsStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchJobs("", "PENDING", 1, undefined, undefined, false, this.getPageSize());
        }
        if (this.props.jobsCount.get("status") === STATE_STATUS.UNFETCHED) {
            this.props.fetchJobsCount(this.state.start_date, this.state.end_date);
        }
    }

    getPageSize = () => {
        return this.props.filter.page_size || DEFAULT_PAGE_SIZE;
    }

    search = _debounce((searchString, start_date, end_date) => {
        if (searchString !== this.state.searchValue) {
            return;
        }
        this.props.fetchJobsCount(start_date, end_date);
        this.props.fetchJobs(searchString, this.props.filter.status, 1, start_date, end_date);
    }, 800);


onSearch = (searchString, start_date, end_date) => {
    const value = searchString ?? "";
    this.setState({ searchValue: value }, () => {
        if (!value) {
            this.search?.cancel?.();
            this.props.fetchJobsCount(start_date, end_date);
            return;
        }

        this.search(value, start_date, end_date);
    });
};

    handleDownload = () => {
        this.props.fetchJobs(
            this.props.filter.search,
            this.props.filter.status,
            this.props.filter.page,
            this.props.filter.start_date,
            this.props.filter.end_date,
            "yes",
            this.getPageSize()
        );
      };
      

    renderDateRangeDiv = () => {
        const { start_date, end_date } = this.props.filter;
        return (
            <div className="d-flex w-100 justify-content-flex-start mt-20 mb-20">
                <RangePicker
                    format="YYYY-MM-DD"
                    placeholder={["Start Date", "End Date"]}
                    disabledDate={(current) =>
                        current && current > moment().endOf("day")
                    }
                    value={
                        start_date && end_date
                        ? [moment(start_date, "YYYY-MM-DD"), moment(end_date, "YYYY-MM-DD")]
                            : null
                    }
                    onChange={(dates, dateStrings) => {
                        if (!dates) {
                            this.setState(
                                {
                                    start_date: null,
                                    end_date: null
                                },
                                () => {
                                    this.props.fetchJobs(
                                        this.props.filter.search,
                                        this.props.filter.status,
                                        1,
                                        null,
                                        null,
                                        false,
                                        this.getPageSize()
                                    );
                                    // this.props.fetchJobsCount(start_date, end_date);
                                }
                            );
                            return;
                        }
                        const [start_date, end_date] = dates;
                        this.setState(
                            {
                                start_date,
                                end_date
                            },
                            () => {
                                this.props.fetchJobs(
                                    this.props.filter.search,
                                    this.props.filter.status,
                                    1,
                                    start_date?.format("YYYY-MM-DD"),
                                    end_date?.format("YYYY-MM-DD"),
                                    false,
                                    this.getPageSize()
                                );
                                this.props.fetchJobsCount(start_date?.format("YYYY-MM-DD"), end_date?.format("YYYY-MM-DD"));
                            }
                        );
                    }}
                />
                <Button
                    type="default"
                    onClick={this.handleDownload}
                    className="download-btn"
                    // disabled={!start_date || !end_date}
                >
                   <Icon type={"mail"} /> E-mail Report
                </Button>
            </div>
        );
    };

    handleSearchChange = (e) => {
        const value = e?.target?.value ?? "";
        const { start_date, end_date, status } = this.props.filter;
        
        this.setState({ searchValue: value }, () => {
            this.search.cancel();
    
            if (!value) {
                this.props.fetchJobs(
                    "",          
                    status,
                    1,
                    start_date,
                    end_date,
                    false,
                    this.getPageSize()
                );
                this.props.fetchJobsCount(start_date, end_date);
                return;
            }
    
            this.search(value, start_date, end_date);
        });
    };
    
    renderHeader = () => {
        return (
            <div className="header-section d-flex justify-content-between align-items-center">
                <Input
                    value={this.state.searchValue}
                    allowClear
                    suffix={null}
                    prefix={
                        <Icon
                            style={{ fontSize: "16px", color: "#8c8c8c" }}
                            type={"search"}
                        />
                    }
                    bordered={true}
                    // onChange={e => this.onSearch(e.target.value, this.props.filter.start_date, this.props.filter.end_date)}
                    onChange={this.handleSearchChange}
                    className={"w-100 search-input vh-10 dealer-search-input"}
                    placeholder="Search dealers"
                />
            </div>
        );
    };

    onJobOpen = _ => {
        if (JOB_STAGES_FOR_REVIEWER.includes(_.stage) || _.stage === JOB_STAGES["Review Initialized"]) {
            this.props.history.push(`/app/companies/invoices/${_.id}`, {
                ...this.props.history.location.state,
                tenorOnUpload: true
            });
             
            return;
        } else {
            return;
        }
    }

    getTableColumns = () => {
        return [
            {
                title: "Dealer",
                dataIndex: "seller_name",
                key: "seller_name",
                render: (_, record) => (
                    <div className={"d-flex flex-row align-items-center"}>
                        <span className={"fw-500-m-0"}>{record.seller_name || "-"}</span>
                        {!JOB_STAGES_FOR_REVIEWER.includes(record.stage) && (
                            <Badge className={"ml-05"} count={"New"} />
                        )}
                    </div>
                )
            },
            {
                title: "Status",
                dataIndex: "status",
                key: "status",
                render: value => <span className={"pending-req"}>{value || "-"}</span>
            },
            {
                title: "Created On",
                dataIndex: "created_on",
                key: "created_on",
                render: value => (value ? moment(value).format("MMM Do, YYYY") : "-")
            },
            {
                title: <span style={{ color: "#27AE60" }}>Approved</span>,
                dataIndex: "auto_approved",
                key: "auto_approved",
                align: "right",
                render: value => value || 0
            },
            {
                title: <span style={{ color: "#27AE60" }}>Manual Approved</span>,
                dataIndex: "manual_approved",
                key: "manual_approved",
                align: "right",
                render: value => value || 0
            },
            {
                title: <span style={{ color: "#F2994A" }}>Pending</span>,
                dataIndex: "pending",
                key: "pending",
                align: "right",
                render: value => value || 0
            },
            {
                title: <span style={{ color: "#463425" }}>Rejected</span>,
                dataIndex: "rejected",
                key: "rejected",
                align: "right",
                render: value => value || 0
            },
            {
                title: <span style={{ color: "#463425" }}>Total Invoices</span>,
                dataIndex: "no_of_invoices",
                key: "no_of_invoices",
                align: "right",
                render: value => value || 0
            },
            {
                title: "",
                key: "action",
                width: 40,
                render: () => <Icon style={{ fontSize: "16px" }} theme={"outlined"} type={"caret-right"} />
            }
        ];
    };
    onStatusChange = status => {
        const { start_date, end_date } = this.props.filter;
        this.props.fetchJobs(
            this.props.filter.search,
            status,
            1,
            start_date, end_date, false, this.getPageSize()
        );
    };

    renderCards = () => {
        return (
            <Card header={null} bordered={false} className={"p-0 border-none no-shadow mt-015 review-invoices-card"} style={{ width: "100%", background: "none" }}>
                {new OrderedMap(this.props.jobsCount.get("data")).map((_, k) => (
                        <div className={`invoice-stat-card ${this.props.filter.status === CARD_STATUS[k] ? "active-card" : ""}`} onClick={() => this.onStatusChange(CARD_STATUS[k])} key={k}>
                            <div className="stat-value">
                                {_}
                            </div>
                            {/* <span className={`${k} stat-label`}>{_}</span>
                        <h4 className={"stat-value fw-500-m-0"}>{CARD_LABELS[k]}</h4> */}
                            <div className="stat-label">
                                {CARD_LABELS[k]}
                            </div>
                        </div>
                    )
                ).toList().toArray()}
            </Card>
        );
    }

    isLoading() {
        if (
            this.props.jobsStatus === STATE_STATUS.FETCHING ||
            this.props.jobsCount.get("status") === STATE_STATUS.FETCHING ||
            this.props.emailStatus === STATE_STATUS.FETCHING
        ) {
            return true;
        }
        return false;
    }

    onPageChange = (page, pageSize) => {
        const { start_date, end_date } = this.props.filter;
        this.props.fetchJobs(
            this.props.filter.search,
            this.props.filter.status,
            page,
            start_date,
            end_date,
            false,
            pageSize || this.getPageSize()
        );
    }

    onPageSizeChange = (_, pageSize) => {
        const { start_date, end_date } = this.props.filter;
        this.props.fetchJobs(
            this.props.filter.search,
            this.props.filter.status,
            1,
            start_date,
            end_date,
            false,
            pageSize
        );
    }

    getSortedJobs = () => {
        return this.props.jobs
            .toList()
            .map(_ => _.get("job"))
            .filter(Boolean)
            .toArray()
            .sort((a, b) => {
                let aTime = moment(a?.created_on);
                let bTime = moment(b?.created_on);
                if (aTime > bTime) {
                    return -1;
                } else if (aTime < bTime) {
                    return 1;
                }
                return 0;
            });
    }

    getPaginationTotal = () => {
        const jobsCountData = this.props.jobsCount.get("data");
        if (jobsCountData && jobsCountData.get) {
            const statusKey = Object.keys(CARD_STATUS).find(key => CARD_STATUS[key] === this.props.filter.status);
            if (statusKey && jobsCountData.get(statusKey) !== undefined) {
                return Number(jobsCountData.get(statusKey)) || 0;
            }
            return Number(jobsCountData.get("total_request_invoices")) || 0;
        }
        return Number(this.props.filter.count) || 0;
    }

    render() {
        // if () {
        //     return (
        //         <Spin className={"d-flex justify-content-center p-10"} />
        //     );
        // }
        return (
            <div className={"d-flex flex-column align-items-center p-20"}>
                <h1 className={"fw-700-m-0"} style={{ fontSize: "26px" }}>Review Invoices</h1>
                {/* <h4 className={"fw-700-m-0"} style={{ fontSize: "16px" }}>Default Listing: 90 Days</h4> */}
                {this.renderCards()}
                {this.renderDateRangeDiv()}
                <div className={"w-100 search-border"}>
                    {this.renderHeader()}
                    <Table
                        loading={this.isLoading()}
                        bordered
                        rowKey={record => record.id}
                        className={"review-invoices-table"}
                        style={{ width: "100%" }}
                        pagination={{
                            current: this.props.filter.page || 1,
                            total: this.getPaginationTotal(),
                            pageSize: this.getPageSize(),
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "20", "50", "100"],
                            onChange: this.onPageChange,
                            onShowSizeChange: this.onPageSizeChange
                        }}
                        columns={this.getTableColumns()}
                        dataSource={this.getSortedJobs()}
                        scroll={{ y: "calc(100vh - 350px)" }}
                        onRow={record => ({
                            onClick: () => this.onJobOpen(record),
                            className: "cursor-pointer"
                        })}
                    />
                </div>
            </div>
        );
    }
}

ReviewInvoices.propTypes = {
    fetchJobs: PropTypes.func,
    fetchJobsCount: PropTypes.func,
    jobs: PropTypes.object,
    jobsStatus: PropTypes.string,
    jobsCount: PropTypes.object,
    history: PropTypes.object,
    filter: PropTypes.object
};

export default ReviewInvoices;

// const mapStateToProps = state => {
//     return {
//         allInvoiceJob: state.companyLosProfiles.get("allInvoiceJob"),
//         invoiceCards: state.companyLosProfiles.get("invoiceCards")
//     };
// };

// const mapDispatchToProps = dispatch =>
//     bindActionCreators(
//         {
//             fetchJobs: fetchAllInvoiceJob,
//             fetchJobCount: fetchInvoiceCards,
//             fetchMarkJobPending
//         },
//         dispatch
//     );

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(ReviewInvoices);